var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDerivedValue = useDerivedValue;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _animation = require("../animation");
var _core = require("../core");
var _PlatformChecker = require("../PlatformChecker");
var _worklet_13223233651811_init_data = {
    code: "function anonymous(){const{sharedValue,processor}=this.__closure;sharedValue.value=processor();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useDerivedValue.ts",
    sourceMap: '{"version":3,"names":["anonymous","sharedValue","processor","__closure","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useDerivedValue.ts"],"mappings":"AAqCgB,SAAAA,SAAMA,CAAA,QAAAC,WAAA,CAAAC,SAAA,OAAAC,SAAA,CAEhBF,WAAW,CAACG,KAAK,CAAGF,SAAS,CAAC,CAAC,CACjC"}',
    version: "3.5.4"
};
function useDerivedValue(processor, dependencies) {
    var _processor$__closure;
    var initRef = (0, _react.useRef)(null);
    var inputs = Object.values((_processor$__closure = processor.__closure) != null ? _processor$__closure : {});
    if ((0, _PlatformChecker.shouldBeUseWeb)()) {
        var _dependencies;
        if (!inputs.length && (_dependencies = dependencies) != null && _dependencies.length) {
            inputs = dependencies;
        }
    }
    if (dependencies === undefined) {
        dependencies = [].concat((0, _toConsumableArray2.default)(inputs), [
            processor.__workletHash
        ]);
    } else {
        dependencies.push(processor.__workletHash);
    }
    if (initRef.current === null) {
        initRef.current = (0, _core.makeMutable)((0, _animation.initialUpdaterRun)(processor));
    }
    var sharedValue = initRef.current;
    (0, _react.useEffect)(function() {
        var fun = function() {
            var _e = [
                new global.Error(),
                -3,
                -27
            ];
            var anonymous = function anonymous() {
                sharedValue.value = processor();
            };
            anonymous.__closure = {
                sharedValue: sharedValue,
                processor: processor
            };
            anonymous.__initData = _worklet_13223233651811_init_data;
            anonymous.__workletHash = 13223233651811;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
        var mapperId = (0, _core.startMapper)(fun, inputs, [
            sharedValue
        ]);
        return function() {
            (0, _core.stopMapper)(mapperId);
        };
    }, dependencies);
    (0, _react.useEffect)(function() {
        return function() {
            initRef.current = null;
        };
    }, []);
    return sharedValue;
}
